import { atom } from "jotai";

export const loginDialog = atom(false);
export const registerDialog = atom(false);
export const forgotPasswordDialog = atom(false);
export const contactDialog = atom(false);
export const proDialog = atom(false);
export const androidReviewDialog = atom(false);
export const isLoggingOutAtom = atom(false);
